import {
  type AdConfigPlacement,
  AdServer,
  Placements,
  type SearchParams
} from '@schibsted-nmp/advertising-shared';

export type RetailMediaParams = {
  searchQuery: string | undefined;
  categories: string[] | undefined;
};

export function hasQueryOrCategories(
  searchParams: SearchParams | null | undefined
): boolean {
  if (!searchParams) return false;
  return !!(
    searchParams.q?.[0]?.trim() ||
    searchParams.category?.length ||
    searchParams.sub_category?.length ||
    searchParams.product_category?.length
  );
}

export function extractRetailMediaParams(
  searchParams: SearchParams | null | undefined
): RetailMediaParams {
  if (!searchParams) {
    return { searchQuery: undefined, categories: undefined };
  }

  const { category } = searchParams;
  const subCategory = searchParams.sub_category;
  const productCategory = searchParams.product_category;

  const categoriesArray = [category, subCategory, productCategory]
    .flat()
    .filter((cat): cat is string => typeof cat === 'string' && cat.length > 0);

  return {
    searchQuery: searchParams.q,
    categories: categoriesArray.length > 0 ? categoriesArray : undefined
  };
}

/** A GAM placement that tries retail media first and backfills with GAM */
export function isRetailMediaOverride(
  placement: AdConfigPlacement | undefined
): boolean {
  return (
    !!placement &&
    Placements.Gam.is(placement) &&
    placement.adServer.config.overrideAdServer === AdServer.Retailmedia
  );
}
